import { NgModule } from '@angular/core';
import { provideTransloco, TranslocoModule, translocoConfig, TRANSLOCO_MISSING_HANDLER } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { environment } from '../environments/environment';

// Custom missing handler for missing translation words
export function placeholderMissingHandler(key: string) {
  console.warn(`Missing translation: ${key}`);
  return key;
}



@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: translocoConfig({
        availableLangs: ['tn', 'ar', 'fr', 'en', 'tr'],
        defaultLang: 'tn',
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          allowEmpty: true,
          logMissingKey: false
        }
      }),
      loader: TranslocoHttpLoader
    }),
    {
      provide: TRANSLOCO_MISSING_HANDLER,
      useValue: { handle: placeholderMissingHandler }
    }
  ]
})
export class TranslocoRootModule {}
